export enum Events {
    LOAD = "load",
    LOAD_ERROR = "loaderror",
    PLAY_ERROR = "playerror",
    PLAY = "play",
    END = "end",
    PAUSE = "pause",
    STOP = "stop",
    MUTE = "mute",
    VOLUME = "volume",
    RATE = "rate",
    SEEK = "seek",
    FADE = "fade",
    UNLOCK = "unlock",
}

export enum State {
    UNLOADED = "unloaded",
    LOADING = "loading",
    LOADED = "loaded",
}
